/**
 * Split hero: pause videos outside viewport
 */
class HeroBannerMediaObserver {
  constructor() {
    this.init();
  }

  init() {
    if (!('IntersectionObserver' in window)) return;

    const panels = document.querySelectorAll('.hero-banner__panel');
    if (panels.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const container = entry.target;

          if (entry.isIntersecting) {
            container.querySelectorAll('deferred-media[data-hero-youtube]:not([loaded])').forEach((media) => {
              if (typeof media.loadContent === 'function') media.loadContent(false);
            });
            container.querySelectorAll('video.hero-banner__video').forEach((video) => {
              video.play().catch(() => {});
            });
          } else {
            container.querySelectorAll('video.hero-banner__video').forEach((video) => video.pause());
            container.querySelectorAll('.js-youtube').forEach((iframe) => {
              iframe.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            });
          }
        });
      },
      { threshold: 0.2 }
    );

    panels.forEach((panel) => observer.observe(panel));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeroBannerMediaObserver();
});

document.addEventListener('shopify:section:load', () => {
  new HeroBannerMediaObserver();
});
